import { MANAGE_PERMISSIONS_STEPS, translationPrefix as translationRootPrefix } from './utils';
import configurationCredentialsImageSrc from '../resources/png/teamManagement/configuration_credentials.png';
import attributionPostbacksImageSrc from '../resources/png/teamManagement/attribution_postbacks.png';
import attributionWindowSettingsImageSrc from '../resources/png/teamManagement/attribution_window_settings.png';
import eventPostbacksImageSrc from '../resources/png/teamManagement/event_postbacks.png';
import linkSettingsAndRedirectsImageSrc from '../resources/png/teamManagement/link_settings_and_redirects.png';
import linkParametersImageSrc from '../resources/png/teamManagement/link_parameters.png';
import linkAttributionSettingsImageSrc from '../resources/png/teamManagement/link_attribution_settings.png';
import linkOgTagsImageSrc from '../resources/png/teamManagement/link_og_tags.png';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

// Preload images
[
    configurationCredentialsImageSrc,
    attributionPostbacksImageSrc,
    attributionWindowSettingsImageSrc,
    eventPostbacksImageSrc,
    linkSettingsAndRedirectsImageSrc,
    linkParametersImageSrc,
    linkAttributionSettingsImageSrc,
    linkOgTagsImageSrc,
].forEach(src => {
    const img = new Image();
    img.src = src;
});

export const SECTIONS_PAGES_CONFIG = [
    {
        step: MANAGE_PERMISSIONS_STEPS.attribution,
        page: {
            link: 'react/partner-config',
            translationKey: `${translationPrefix}.ATTRIBUTION.PAGE_DISPLAY_NAME`,
        },
        cards: [
            {
                title: `${translationPrefix}.ATTRIBUTION.TITLE`,
                description: `${translationPrefix}.ATTRIBUTION.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: ['partner-configuration-credentials'],
                        tooltipImageSrc: configurationCredentialsImageSrc,
                        tooltipDescriptionSectionName: 'partner-configuration-credentials',
                    },
                    {
                        displayName: `${translationPrefix}.ATTRIBUTION.ATTRIBUTION_POSTBACKS.DISPLAY_NAME`,
                        sectionNames: [
                            'partner-configuration-attribution-install-postbacks',
                            'partner-configuration-attribution-reengagement-postbacks',
                        ],
                        tooltipImageSrc: attributionPostbacksImageSrc,
                    },
                    {
                        sectionNames: ['partner-configuration-attribution-window-settings'],
                        tooltipImageSrc: attributionWindowSettingsImageSrc,
                        viewOnly: true, // For now, we only show the attribution window settings in view-only mode
                    },
                    {
                        sectionNames: ['partner-configuration-in-app-events-postback'],
                        tooltipImageSrc: eventPostbacksImageSrc,
                    },
                ],
            },
        ],
    },
    {
        step: MANAGE_PERMISSIONS_STEPS.links,
        page: {
            link: 'react/link-management',
            translationKey: `${translationPrefix}.LINKS.PAGE_DISPLAY_NAME`,
        },
        cards: [
            {
                title: `${translationPrefix}.LINKS.TITLE`,
                description: `${translationPrefix}.LINKS.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: ['manage-links-partner-link-settings-and-redirects'],
                        tooltipImageSrc: linkSettingsAndRedirectsImageSrc,
                    },
                    {
                        sectionNames: ['manage-links-partner-attribution-settings'],
                        tooltipImageSrc: linkAttributionSettingsImageSrc,
                    },
                    {
                        sectionNames: ['manage-links-custom-link-settings-and-redirects'],
                        tooltipImageSrc: linkSettingsAndRedirectsImageSrc,
                    },
                    {
                        sectionNames: ['manage-links-custom-attribution-settings'],
                        tooltipImageSrc: linkAttributionSettingsImageSrc,
                    },
                    {
                        sectionNames: ['manage-links-custom-og-tags'],
                        tooltipImageSrc: linkOgTagsImageSrc,
                    },
                    {
                        sectionNames: ['manage-links-custom-link-parameters'],
                        tooltipImageSrc: linkParametersImageSrc,
                    },
                ],
            },
        ],
    },
];

export const SECTION_PAGES_STEPS = SECTIONS_PAGES_CONFIG.map(({ step }) => step);
